import config from '../../config';
import AnimatedParticle from './AnimatedParticle';

let soundManager;
let dataManager;

// TODO: Add on complete call back
function OpenAllBoxes (cb, countCoins = false) {
  let g = this.g;
  if (!dataManager) {
    soundManager = g.scene.get('SoundManager');
    dataManager = g.sys.game.dataManager;
  }
  this.removeListeners();
  let remainingTiles = _.reverse(_.filter(this.tiles, 'isActive'));
  let particle = g.add.particles('packing');
  let emitter = particle.createEmitter({
    x: config.CENTER_X,
    y: config.CENTER_Y,
    speed: { min: 50, max: 400 },
    accelerationX: { min: -50, max: 50 },
    accelerationY: { min: -50, max: 50 },
    angle: { min: 0, max: 360 },
    // scale: { start: 0, end: 0.5 },
    scale: 0.2,
    lifespan: 1250,
    particleClass: AnimatedParticle,
    on: false
  });
  _.each(remainingTiles, (tile, i) => {
    tile.setHot();
    let frameName = tile.sprite.frame.name;

    g.time.delayedCall(i * 50, () => {
      let tl = g.tweens.createTimeline();
      tile.sprite.setScale(0.9);
      tile.sprite.setAngle(-5);
      tl.add({
        targets: tile.sprite,
        angle: 5,
        yoyo: true,
        repeat: 1,
        duration: 100
      });
      tl.add({
        targets: tile.sprite,
        angle: 0,
        scaleX: 1,
        scaleY: 1,
        duration: 100,
        onComplete: () => {
          soundManager.playSound('box-open');
          tile.sprite.setTexture('tiles-open');
          tile.sprite.setFrame(frameName);
          dataManager.addPoints(config.POINTS.MATCH);
          if (countCoins) {
            dataManager.addCoins(config.COINS_PER_BOX);
          }
          // console.log('standard match points');
          // bear reveal
          if (tile.bearType) {
            switch (tile.bearType) {
              case 'grizz':
                soundManager.playSound('vo-found-grizz');
                break;
            }
            // console.log('Bear Tile', tile);
            dataManager.addPoints(config.POINTS.BEAR);
            // console.log('bear points');
            let bear = g.add.sprite(tile.sprite.x, tile.sprite.y, 'play-bears');
            bear.setFrame(tile.bearType + '1.png');
            bear.setScale(0.125);
            let bearTimeline = g.tweens.createTimeline();
            bearTimeline.add({
              targets: bear,
              scaleX: 0.25,
              scaleY: 0.25,
              ease: 'Back.easeOut',
              duration: 750,
              delay: 100
            });
            bearTimeline.add({
              targets: bear,
              scaleX: 0.5,
              scaleY: 0.5,
              alpha: 0,
              // ease: 'Back.easeOut',
              delay: 500,
              duration: 250
            });
            bearTimeline.play();
          }
          // collectable reveal
          if (tile.collectableType) {
            let collectableType = tile.collectableType;
            // session collectable count, used for increasing the score for each one found throughout a play session
            let sessionCollectableCount = dataManager.getSessionItem('collectableCount');
            // increase the collectable count if it is less than the total number of collectables available
            sessionCollectableCount = sessionCollectableCount < config.COLLECTABLE_TOTAL ? sessionCollectableCount + 1 : config.COLLECTABLE_TOTAL;
            // save the session count
            dataManager.setSessionItem('collectableCount', sessionCollectableCount);
            // collectableState keeps track of what items we have already found
            let collectableState = dataManager.getItem('collectables');
            // inital length check to see if we've already found all items
            if (collectableState.length < config.COLLECTABLE_TOTAL) {
              // if so, check if the item already exists in the collectableState array
              if (collectableState.indexOf(collectableType) === -1) {
                console.log('OpenAllBoxes.js New Collectable Found', collectableType);
                collectableState.push(collectableType);
                dataManager.setItem('collectables', collectableState);
  
              } else {
                console.log('OpenAllBoxes.js Already collected', collectableState);
              }
            } else {
              console.log('OpenAllBoxes.js All collectables already found');
            }
            // console.log('Collectable Tile', tile);
            soundManager.playSound('vo-found-object');
            let collectablePointValue = config.POINTS.COLLECTABLE * sessionCollectableCount;
            console.log('OpenAllBoxes.js collectablePointValue', collectablePointValue);
            dataManager.addPoints(collectablePointValue);
            // console.log('Collectable points', collectablePointValue);
            let collectable = g.add.sprite(tile.sprite.x, tile.sprite.y, 'collectables');
            collectable.setFrame(tile.collectableType);
            collectable.setScale(0.125);
            let collectableTimeline = g.tweens.createTimeline();
            collectableTimeline.add({
              targets: collectable,
              scaleX: 0.25,
              scaleY: 0.25,
              ease: 'Back.easeOut',
              duration: 750,
              delay: 100
            });
            collectableTimeline.add({
              targets: collectable,
              scaleX: 0.5,
              scaleY: 0.5,
              alpha: 0,
              // ease: 'Back.easeOut',
              delay: 500,
              duration: 250
            });
            collectableTimeline.play();
          }
          emitter.explode(50, tile.sprite.x, tile.sprite.y);
        }
      });
      tl.add({
        targets: tile.sprite,
        alpha: 0,
        duration: 500,
        delay: 500,
        onComplete: () => {
          if (i + 1 === remainingTiles.length) {
            cb();
          }
        }
      });
      tl.play();
    });
  });
}

export default OpenAllBoxes;
